import React from 'react';
import S from './SensorHistoryPopup.module.scss';

const formatDate = (val) => {
  if (val === null || val === undefined) return '—';
  const ts = typeof val === 'number' ? val * 1000 : new Date(val).getTime();
  if (!Number.isFinite(ts)) return '—';
  return new Date(ts).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

const UPDATE_TYPE_LABEL = {
  Edit: 'Modification',
  Delete: 'Suppression',
  Restore: 'Restauration',
  Added: 'Ajout',
};

const UPDATE_TYPE_CLASS = {
  Edit: S.typeEdit,
  Delete: S.typeDelete,
  Restore: S.typeRestore,
  Added: S.typeAdded,
};

const SensorHistoryPopup = ({ row, entries, sensorName, onClose }) => {
  const sorted = [...entries].sort((a, b) => {
    const toTs = (v) =>
      typeof v === 'number' ? v : Math.floor(new Date(v ?? 0).getTime() / 1000);
    return toTs(a.modification_date) - toTs(b.modification_date);
  });

  return (
    <div
      className={S.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className={S.popup} onClick={(e) => e.stopPropagation()}>
        <div className={S.header}>
          <h3>
            Historique — {sensorName} · PK {row?.pk_test}
          </h3>
          <button
            type="button"
            className={S.btnClose}
            onClick={onClose}
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>

        <div className={S.body}>
          {sorted.length === 0 ? (
            <p className={S.empty}>Aucun historique disponible.</p>
          ) : (
            sorted.map((entry, i) => (
              <div key={entry.id ?? i} className={S.entry}>
                <div className={S.entryHeader}>
                  <span className={S.entryTitle}>
                    Date de modification numéro {i + 1}
                  </span>
                  <span
                    className={`${S.updateTypeBadge} ${UPDATE_TYPE_CLASS[entry.update_type] ?? ''}`}
                  >
                    {UPDATE_TYPE_LABEL[entry.update_type] ?? entry.update_type}
                  </span>
                  <span className={S.entryDate}>
                    {formatDate(entry.modification_date)}
                  </span>
                </div>

                <table className={S.entryTable}>
                  <tbody>
                    <tr>
                      <td>Ancien timestamp</td>
                      <td>{formatDate(entry.old_time_unix)}</td>
                    </tr>
                    <tr>
                      <td>Nouveau timestamp</td>
                      <td>{formatDate(entry.new_time_unix)}</td>
                    </tr>
                    <tr>
                      <td>Ancienne valeur</td>
                      <td>{entry.old_value ?? '—'}</td>
                    </tr>
                    <tr>
                      <td>Nouvelle valeur</td>
                      <td>{entry.new_value ?? '—'}</td>
                    </tr>
                    <tr>
                      <td>Ancienne valeur calculée</td>
                      <td>{entry.old_calc_value ?? '—'}</td>
                    </tr>
                    <tr>
                      <td>Nouvelle valeur calculée</td>
                      <td>{entry.new_calc_value ?? '—'}</td>
                    </tr>
                    <tr>
                      <td>Utilisateur</td>
                      <td>{entry.user_name ?? entry.user_id ?? '—'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SensorHistoryPopup;
